import React from 'react';
import PropTypes from 'prop-types';
import { Image, Text, MarkdownWrapper } from 'components/atoms';
import { pageTypes } from 'config/pageTypes';
import './SizeGuideCard.scss';

const SizeGuideCard = ({
	title,
	description,
	size,
	content,
	imageSrc,
	imageAlt,
	contentAlign,
	removeMinHeight,
	pageType,
}) => {
	return (
		<div className="size-guide-card">
			<div
				className={`card-header ${removeMinHeight ? 'fit-content-height' : ''}`}
			>
				{imageSrc && (
					<Image
						src={imageSrc}
						alt={imageAlt}
						className="card-icon"
						lazyLoading={true}
					/>
				)}

				<span className="card-title">{title}</span>
				{description && (
					<Text
						className="card-description"
						size="smallMedium"
						weight="standard"
						color="darkGray"
					>
						{description}
					</Text>
				)}

				{size && (
					<div className="card-size">
						<Text
							size="smallMedium"
							weight="standard"
							color="black"
						>
							{size}
						</Text>
					</div>
				)}
			</div>

			<div
				className={`card-blue-section${pageType === pageTypes.SGP ? ' sgp' : ''}`}
			>
				<div className="blue-block">
					<MarkdownWrapper
						className={contentAlign}
						content={[{ value: content }]}
					/>
				</div>
			</div>
		</div>
	);
};

SizeGuideCard.propTypes = {
	title: PropTypes.string.isRequired,
	description: PropTypes.string,
	size: PropTypes.string,
	content: PropTypes.string.isRequired,
	imageSrc: PropTypes.string,
	imageAlt: PropTypes.string,
	contentAlign: PropTypes.oneOf(['text-left', 'text-center', 'text-right']),
	removeMinHeight: PropTypes.bool,
	pageType: PropTypes.oneOf([pageTypes.PSP, pageTypes.SGP]),
};

SizeGuideCard.defaultProps = {
	imageAlt: 'storage unit',
	size: '',
	contentAlign: 'text-center',
};

export default SizeGuideCard;
